import { render, staticRenderFns } from "./AddendumCard.vue?vue&type=template&id=59de5057&scoped=true&"
import script from "./AddendumCard.vue?vue&type=script&lang=js&"
export * from "./AddendumCard.vue?vue&type=script&lang=js&"
import style0 from "./AddendumCard.vue?vue&type=style&index=0&id=59de5057&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de5057",
  null
  
)

export default component.exports